(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cx-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initProduct(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.cxp-form');
    const variants = JSON.parse(root.querySelector('[data-cxp-variants]').textContent);
    const quantity = root.querySelector('[data-cxp-quantity-input]');
    const mainAdd = root.querySelector('[data-cxp-main-add]');
    const stickyAdd = root.querySelector('[data-cxp-sticky-add]');
    const formatter = new Intl.NumberFormat(root.dataset.locale || 'nl', {style:'currency', currency:root.dataset.currency || 'EUR'});
    const selected = () => variants.find(v => String(v.id) === String(new FormData(form).get('id'))) || variants[0];
    function syncBusy() {
      const disabled = !selected().available || form.dataset.cxAdding === 'true';
      mainAdd.disabled = disabled;
      stickyAdd.disabled = disabled;
      if (form.dataset.cxAdding === 'true') stickyAdd.setAttribute('aria-busy','true');
      else stickyAdd.removeAttribute('aria-busy');
    }
    function clampQuantity() {
      const v = selected();
      const minimum = Number(v.min) || 1;
      const step = Number(v.step) || 1;
      let value = Number(quantity.value);
      if (!Number.isFinite(value)) value = minimum;
      value = minimum + Math.max(0, Math.floor((value - minimum) / step)) * step;
      if (v.max != null) value = Math.min(Number(v.max),value);
      quantity.value = String(value);
      root.querySelector('[data-cxp-quantity="-1"]').disabled = value <= minimum;
      root.querySelector('[data-cxp-quantity="1"]').disabled = v.max != null && value >= Number(v.max);
    }
    function variantChanged(updateUrl) {
      const v = selected();
      root.querySelector('[data-cxp-price]').textContent = formatter.format(v.price / 100);
      root.querySelector('[data-cxp-sticky-price]').textContent = formatter.format(v.price / 100);
      const compare = root.querySelector('[data-cxp-compare]');
      compare.hidden = !(v.compare > v.price);
      compare.textContent = v.compare > v.price ? formatter.format(v.compare / 100) : '';
      root.querySelector('[data-cxp-stock]').dataset.available = String(v.available);
      root.querySelector('[data-cxp-stock-text]').textContent = v.available ? root.dataset.stockLabel : root.dataset.soldLabel;
      mainAdd.querySelector('span')?.replaceChildren(document.createTextNode(v.available ? root.dataset.addLabel : root.dataset.soldLabel));
      stickyAdd.querySelector('span')?.replaceChildren(document.createTextNode(v.available ? root.dataset.stickyLabel : root.dataset.soldLabel));
      quantity.min = String(v.min || 1);
      quantity.step = String(v.step || 1);
      if (v.max != null) quantity.max = String(v.max); else quantity.removeAttribute('max');
      root.querySelectorAll('[data-cxp-weight]').forEach(el => {el.textContent = v.title;});
      clampQuantity();syncBusy();
      if (updateUrl) {const url = new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}
    }
    form.querySelectorAll('[data-cxp-variant]').forEach(input => input.addEventListener('change',() => variantChanged(true)));
    root.querySelectorAll('[data-cxp-quantity]').forEach(button => button.addEventListener('click',() => {quantity.value = String(Number(quantity.value) + Number(button.dataset.cxpQuantity) * (Number(quantity.step) || 1));clampQuantity();}));
    quantity.addEventListener('change',clampQuantity);
    new MutationObserver(syncBusy).observe(form,{attributes:true,attributeFilter:['data-cx-adding']});
    const dialog = root.querySelector('.cxp-lightbox');
    const mainImage = root.querySelector('.cxp-main-image');
    const zoom = root.querySelector('[data-cxp-zoom]');
    zoom?.addEventListener('click',event => {if (typeof dialog.showModal !== 'function') return;event.preventDefault();const image = root.querySelector('[data-cxp-large-image]');image.src = zoom.href;image.alt = mainImage.alt;dialog.showModal();});
    root.querySelector('[data-cxp-close]').addEventListener('click',() => dialog.close());
    dialog.addEventListener('click',event => {if(event.target !== dialog)return;const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();});
    root.querySelectorAll('[data-cxp-thumbnail]').forEach(thumb => thumb.addEventListener('click',event => {if(!mainImage||!zoom)return;event.preventDefault();mainImage.removeAttribute('srcset');mainImage.removeAttribute('sizes');mainImage.src=thumb.dataset.image;mainImage.alt=thumb.dataset.alt;mainImage.width=Number(thumb.dataset.width);mainImage.height=Number(thumb.dataset.height);zoom.href=thumb.dataset.full;root.querySelectorAll('[data-cxp-thumbnail]').forEach(t=>t.setAttribute('aria-current',String(t===thumb)));}));
    variantChanged(false);
  }
  function initAll(scope) {scope.querySelectorAll('[data-cxp]').forEach(initProduct);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll(document));else initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  document.addEventListener('click',event=>{document.querySelectorAll('.cxp-header-search[open],.cxp-header-menu[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;});});
  document.addEventListener('toggle',event=>{const target=event.target;if(!(target instanceof HTMLDetailsElement)||!target.open||!target.matches('.cxp-header-search,.cxp-header-menu'))return;document.querySelectorAll('.cxp-header-search[open],.cxp-header-menu[open]').forEach(d=>{if(d!==target)d.open=false;});},true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.cxp-header-search[open],.cxp-header-menu[open]').forEach(d=>d.open=false);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
